import React from 'react'

import CancelBooking from 'components/CancelBooking'
import ServiceCancellationPenalty from 'components/ServiceCancellationPenalty'
import { formatDate } from 'utils/dates'

class CancelService extends CancelBooking {
  constructor (props) {
    super(props)

    this.bookingName = 'servicio'
  }

  renderPenalty (props) {
    const {
      bookingId,
      onPenaltyFetched
    } = props

    return (
      <ServiceCancellationPenalty
        serviceId={bookingId}
        onPenaltyFetched={onPenaltyFetched}
      />
    )
  }

  renderInfo ({ booking }) {
    const serviceDateFormat = 'dddd D [de] MMMM [a las] H:mm A'
    const serviceDate = formatDate(serviceDateFormat, booking && booking.datetime)

    return <p>Estás a punto de cancelar tu servicio del <b>{serviceDate}</b>.</p>
  }
}

export default CancelService



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/CancelService/CancelService.js